import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Formik/Input/Input';
import { _Fieldset as Fieldset, _Legend as Legend } from '../Styled/Fieldset';

export const ContactDetails = ({ fields, localization, handleChange }) => {
  const labels = localization.text.contactLabels;
  const countryCode = localization.text.countryCode;

  // Define the order in which we want to render the fields
  const fieldOrder = ['name', 'address', 'postalCode', 'city', 'phone', 'email'];

  if (!fields || fields.length === 0) {
    return null;
  }

  const getFieldType = (fieldName) => {
    switch (fieldName) {
      case 'postalCode':
        return 'number';
      case 'phone':
        return 'tel';
      case 'email':
        return 'email';
      default:
        return 'text';
    }
  };

  return (
    <Fieldset>
      {fields.length > 1 && <Legend>{labels.heading}:</Legend>}
      {fieldOrder.map((fieldName) => {
        if (fields.includes(fieldName)) {
          return (
            <Input
              key={fieldName}
              id={`contact-${fieldName.toLowerCase()}`}
              props={{
                label: labels[fieldName],
                name: `contact.${fieldName}`,
                type: getFieldType(fieldName),
                initialValue: fieldName === 'phone' && countryCode,
                required: true,
                handleChange: handleChange
              }}
            />
          );
        }
        return null;
      })}
    </Fieldset>
  );
};

ContactDetails.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  localization: PropTypes.object.isRequired,
};
